import axios from 'axios';

const API_ORIGIN =
  process.env.REACT_APP_API_BASE ||
  (['localhost', '127.0.0.1'].includes(window.location.hostname)
    ? 'http://localhost:3001'
    : '');

const normalizedApiOrigin = API_ORIGIN.replace(/\/$/, '');
const API_BASE = normalizedApiOrigin.endsWith('/api')
  ? normalizedApiOrigin
  : `${normalizedApiOrigin}/api`;

const buildFamilyParams = (selectedFamilies = []) => (
  Array.isArray(selectedFamilies) && selectedFamilies.length
    ? { selectedFamilies: selectedFamilies.join(',') }
    : {}
);

export async function fetchFailureRateMonthly({ startDate, endDate, selectedFamilies = [] }) {
  const response = await axios.get(`${API_BASE}/failure-rate-monthly`, {
    params: {
      startDate: startDate ? startDate.toISOString().split('T')[0] : '',
      endDate: endDate ? endDate.toISOString().split('T')[0] : '',
      ...buildFamilyParams(selectedFamilies),
    },
  });
  return response.data;
}

export async function fetchParetoFailureAnalysis(params = {}) {
  const response = await axios.get(`${API_BASE}/pareto-failure-analysis`, { params });
  return response.data;
}

export async function fetchTotalProduction(params = {}) {
  const response = await axios.get(`${API_BASE}/total-production`, { params });
  return response.data.totalProduction;
}

export async function fetchUutStatusCount(params = {}) {
  const response = await axios.get(`${API_BASE}/uut-status-count`, { params });
  return {
    PASS: Number(response.data?.PASS) || 0,
    FAIL: Number(response.data?.FAIL) || 0,
  };
}

export async function fetchUniqueSerialCount() {
  const response = await axios.get(`${API_BASE}/unique-serial-count`);
  return response.data.uniqueSerialCount || 0;
}

export async function fetchDashboardDataByFilter(filter, selectedFamilies = []) {
  const [paretoData, totalProduction, pieData] = await Promise.all([
    fetchParetoFailureAnalysis({ filter, ...buildFamilyParams(selectedFamilies) }),
    fetchTotalProduction({ filter, ...buildFamilyParams(selectedFamilies) }),
    fetchUutStatusCount({ filter, ...buildFamilyParams(selectedFamilies) }),
  ]);

  return {
    uniqueSerialCount: paretoData?.uniqueSerialCount || 0,
    paretoData,
    totalProduction,
    pieData,
  };
}

export async function fetchDashboardDataByDateRange({ startDate, endDate, selectedFamilies = [] }) {
  const start = startDate ? startDate.toISOString().split('T')[0] : '';
  const end = endDate ? endDate.toISOString().split('T')[0] : '';
  const params = { startDate: start, endDate: end, ...buildFamilyParams(selectedFamilies) };

  const [pieData, paretoData, totalProduction] = await Promise.all([
    fetchUutStatusCount(params),
    fetchParetoFailureAnalysis(params),
    fetchTotalProduction(params),
  ]);

  return {
    pieData,
    paretoData: Array.isArray(paretoData) ? paretoData : [],
    totalProduction,
  };
}
